import { render, staticRenderFns } from "./Behance.vue?vue&type=template&id=36062f16&scoped=true"
import script from "./Behance.vue?vue&type=script&lang=js"
export * from "./Behance.vue?vue&type=script&lang=js"
import style0 from "./Behance.vue?vue&type=style&index=0&id=36062f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36062f16",
  null
  
)

export default component.exports